import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";

const LendTrack = ({}) => {
  const { track: lendData } = useSelector((state) => state.service);

  return (
    <>
      <div className="col-12 col-lg-12">
        <div className="apply_loan_right_container p-4">
          <h1 className="mb-0 text-white display-5 fw500">
            Track Transaction (Crypto Loan)
          </h1>
          <br />
          <div className="row gy-4">
            <div className="col-12 col-md-6">
              <label className="text-white mb-1 fw600" htmlFor="Loan Amount">
                Status
              </label>
              <br />
              <input
                type="text"
                name="Loan Amount"
                id="Loan Amount"
                className="inp_control"
                value={lendData?.status}
              />
            </div>
            <div className="col-12 col-md-6">
              <label className="text-white mb-1 fw600" htmlFor="Loan Amount">
                Loan Coin
              </label>
              <br />
              <input
                type="text"
                name="Loan Amount"
                id="Loan Amount"
                className="inp_control"
                value={lendData?.lendCoin?.name}
              />
            </div>
            <div className="col-12 col-md-6">
              <label className="text-white mb-1 fw600" htmlFor="Loan Amount">
                Loan Quantity
              </label>
              <br />
              <input
                type="text"
                name="Loan Amount"
                id="Loan Amount"
                className="inp_control"
                value={lendData?.quantity}
                disabled
              />
            </div>

            <div className="col-12 col-md-6">
              <label
                className="text-white mb-1 fw600"
                htmlFor="Collateral Required"
              >
                Collateral Coin
              </label>
              <br />
              <input
                type="text"
                name="Collateral Required"
                id="Collateral Required"
                className="inp_control"
                value={lendData?.collateralCoin?.name}
                disabled={true}
              />
            </div>
            <div className="col-12 col-md-6">
              <label
                className="text-white mb-1 fw600"
                htmlFor="Collateral Required"
              >
                Collateral Quantity
              </label>
              <br />
              <input
                type="text"
                name="Collateral Required"
                id="Collateral Required"
                className="inp_control"
                value={lendData?.collateralRequired}
                disabled={true}
              />
            </div>

            <div className="col-12 col-md-6 d-flex flex-column">
              <label className="text-white mb-1 fw600" htmlFor="Coin">
                Total to be paid back
              </label>
              <div className=" d-flex">
                {/* <button>Total</button> */}
                <input
                  type="text"
                  name="Coin"
                  id="Coin"
                  className="inp_control"
                  value={`${lendData?.totalTobePaid}`}
                  disabled={true}
                />
              </div>
            </div>

            <div className="col-12 col-md-6">
              <label
                className="text-white mb-1 fw600"
                htmlFor="Collateral Required"
              >
                Outstanding loan
              </label>
              <br />
              <input
                type="text"
                name="Collateral Required"
                id="Collateral Required"
                className="inp_control"
                value={lendData?.totalTobePaid - lendData?.partialRepayment}
                disabled={true}
              />
            </div>

            <div className="col-12 col-md-6">
              <label className="text-white mb-1 fw600" htmlFor="Email Address">
                Loan Start Date
              </label>
              <input
                type="email"
                name="Collateral Required"
                id="Collateral Required"
                className="inp_control"
                placeholder="Enter your email"
                value={moment(lendData.loanStartDate).format(
                  "MMMM Do YYYY, h:mm:ss a"
                )}
                disabled
              />
            </div>

            <div className="col-12 col-md-6">
              <label className="text-white mb-1 fw600" htmlFor="Email Address">
                Loan End Date
              </label>
              <input
                type="email"
                name="Collateral Required"
                id="Collateral Required"
                className="inp_control"
                placeholder="Enter your email"
                value={moment(lendData.loanEndDate).format(
                  "MMMM Do YYYY, h:mm:ss a"
                )}
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LendTrack;
